/* eslint-disable no-alert */
import React, { useRef } from 'react';
import { Button, Modal, Spinner, Tab, Tabs } from 'react-bootstrap';
import { ActionModal } from './styles';

import { toast } from 'react-toastify';
import {
  CadastroRapidoProduto,
  CadastroRapidoProdutoHandle,
} from '~/components/CadastroRapidoProduto';
import { revalidaItem } from '../../Funcoes/Correcao';
import { ProductDataToTable } from '../../protocols';
import { useValidadorXML } from '../../ValidadorContext';
import { useModalDeCorrecoes } from './ModalDeCorrecoesContext';
import { NovoCFOP, NovoNCM, NovoProduto } from './protocols';
import {
  AlterarCFOP,
  AlterarNCM,
  CodigoDeBarras,
  Home,
  SubstituirProduto,
} from './screens';

const ModalDeCorrecoesContent: React.FC = () => {
  const {
    modalTab,
    setModalTab,
    dadosItemACorrigir,
    resetModalOnClose,
    confirmarAlteracao,
    funcaoConfirmar,
    loading,
    setFiltroOrigem,
    setFiltroStatus,
    handleFiltrosOrigem,
    handleFiltrosStatus,
    setNovoNCM,
    setNovoCFOP,
    setShowData,
    listaDeStatus,
    handleResponseData,
    abrirCadastroRapidoDepois,
    setAbrirCadastroRapidoDepois,
    setDadosItemACorrigir,
  } = useModalDeCorrecoes();

  const {
    showModalDeCorrecoes,
    setShowModalDeCorrecoes,
    parametrosValidacao,
    dadosDaCapa,
    dadosErpDoFornecedor,
    onSetItemACorrigir,
  } = useValidadorXML();

  const cadastroRef = useRef<CadastroRapidoProdutoHandle>(null);
  const itemParaCadastroRef = useRef<ProductDataToTable | null>(null);

  const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  return (
    <>
      <ActionModal
        show={showModalDeCorrecoes}
        onHide={() => {
          setFiltroOrigem('TODOS');
          setFiltroStatus('TODOS');
          handleFiltrosOrigem('TODOS');
          handleFiltrosStatus('TODOS');

          if (abrirCadastroRapidoDepois) {
            itemParaCadastroRef.current = dadosItemACorrigir;
          } else {
            onSetItemACorrigir({} as ProductDataToTable);
          }

          setShowModalDeCorrecoes(false);
          resetModalOnClose();
          setNovoNCM({} as NovoNCM);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // size="xl"
        backdrop={!loading || 'static'}
        dialogClassName="custom-modal"
        onExited={() => {
          if (abrirCadastroRapidoDepois) {
            cadastroRef.current?.open();
            setAbrirCadastroRapidoDepois(false);
          }
        }}
      >
        <Modal.Header>
          <Modal.Title>{`Nº Item: ${dadosItemACorrigir.index} - cEAN: ${dadosItemACorrigir.cEAN} - xProd: ${dadosItemACorrigir.xProd}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            id="controlled-tab-status"
            activeKey={modalTab}
            onSelect={(k) => {
              setModalTab(`${k}`);
            }}
          >
            {/* 951,78 */}
            <Tab eventKey="filtros" title="teste">
              <Home />
            </Tab>
            <Tab eventKey="substituirProduto" title="">
              <SubstituirProduto />
            </Tab>
            <Tab eventKey="adicionarProdutoNoMix" title="">
              Adicionar Produto no Mix
            </Tab>
            <Tab eventKey="retornarEmLinha" title="">
              Retornar em linha
            </Tab>
            <Tab eventKey="atualizarUnCompraERef" title="">
              Atualizar Unidade de Compra ou Referência
            </Tab>
            <Tab eventKey="atualizarCodigoDeBarras" title="">
              <CodigoDeBarras />
            </Tab>
            <Tab eventKey="alterarNCM" title="">
              <AlterarNCM />
            </Tab>
            <Tab eventKey="alterarCFOP" title="">
              <AlterarCFOP />
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setNovoNCM({} as NovoNCM);
              setNovoCFOP({} as NovoCFOP);
              setShowData('');
              if (modalTab !== 'filtros') {
                setModalTab('filtros');
              } else {
                setFiltroOrigem('TODOS');
                setFiltroStatus('TODOS');
                handleFiltrosOrigem('TODOS');
                handleFiltrosStatus('TODOS');
                setShowModalDeCorrecoes(false);
                resetModalOnClose();
                onSetItemACorrigir({} as ProductDataToTable);
              }
            }}
          >
            {modalTab !== 'filtros' ? 'Voltar' : 'Fechar'}
          </Button>
          {modalTab !== 'filtros' && (
            <Button
              variant="primary"
              onClick={async () => {
                confirmarAlteracao(funcaoConfirmar);

                if (loading) {
                  const response = await revalidaItem({
                    dadosItemACorrigir,
                    listaDeStatus,
                    parametrosValidacao,
                    dadosDaCapa,
                    dadosErpDoFornecedor,
                  });

                  await handleResponseData({
                    response,
                    campo: 'nenhum',
                    origem: 'nenhum',
                  });
                }

                if (
                  (modalTab !== 'filtros' && loading) ||
                  (modalTab === 'atualizarCodigoDeBarras' && !loading)
                ) {
                  setModalTab('filtros');
                }
              }}
              disabled={loading}
              style={{
                display: 'flex',
                height: '38px',
                width: '94px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {loading ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                'Confirmar'
              )}
            </Button>
          )}
        </Modal.Footer>
      </ActionModal>

      <CadastroRapidoProduto
        ref={cadastroRef}
        codTela={58}
        showTrigger={false}
        buttonText="CADASTRO SIMPLIFICADO"
        onSuccess={async (produtoCriado) => {
          try {
            const novo: NovoProduto = {
              cod_produto: String(produtoCriado?.cod_produto ?? ''),
              cod_gtin_principal: String(
                produtoCriado?.cod_gtin_principal ??
                  produtoCriado?.cod_gtin ??
                  produtoCriado?.gtin ??
                  '',
              ),
            } as NovoProduto;

            if (!novo.cod_produto) {
              toast.warning(
                'Produto cadastrado, mas não foi possível ler o código do produto para vincular ao item.',
              );
              return;
            }

            if (itemParaCadastroRef.current)
              setDadosItemACorrigir(itemParaCadastroRef.current);

            confirmarAlteracao('substituirProduto', { novoProduto: novo });

            await delay(500);

            itemParaCadastroRef.current = null;
          } catch (e) {
            toast.warning(
              'Ocorreu um erro ao tentar vincular o produto cadastrado ao item da NF-e.',
            );
          }
        }}
      />
    </>
  );
};

export default ModalDeCorrecoesContent;
